'use client';

import { 
  ControlType, 
  CalculatorId, 
  CalculatorType,
  ControlIds,
  type CalculatorConfig,
  DataTableInputMode,
  type ControlValues,
  type SingleColumnSelectControl
} from '../../../lib/calculators/calculator-config';
import { TableDataJSON } from '../../../src/types/table-json';
import { RangeCalculator } from './range-calculator';
import { calculateRange } from '../../../lib/stats/range';

export interface RangeControlValues extends ControlValues {
  [ControlIds.Values]: string;
}

export const rangeControls = {
  tabs: [
    {
      title: 'Data',
      controls: [
        {
          id: ControlIds.Values,
          type: ControlType.SingleColumnSelect,
          label: 'Select Data Column',
          required: true,
          numericOnly: true,
          defaultValue: 'scores'
        } as SingleColumnSelectControl
      ]
    }
  ]
};

export const rangeCalculatorConfig: CalculatorConfig<CalculatorId.RANGE> = {
  id: CalculatorId.RANGE,
  type: CalculatorType.Graph,
  name: 'Range Calculator',
  dataTableInputMode: DataTableInputMode.Required,
  initialData: TableDataJSON.from({
    columns: [
      { 
        id: 'scores',
        name: 'Test Scores', 
        values: ['65', '70', '75', '80', '85', '90', '95', '85', '80', '75', '95', '100', '60', '75', '85'] 
      },
      {
        id: 'temperatures',
        name: 'Temperature (°F)',
        values: ['68', '72', '75', '69', '71', '73', '77', '70', '74', '76', '72', '75', '78', '71', '73']
      },
      {
        id: 'prices',
        name: 'Stock Prices ($)',
        values: ['25.4', '26.2', '24.8', '25.9', '26.3', '25.1', '24.9', '25.7', '26.1', '25.3', '25.8', '26.0']
      }
    ]
  }),
  initialControlValues: {
    [ControlIds.Values]: 'scores'
  },
  controls: rangeControls,
  getInitialConfig: (data: TableDataJSON) => ({
    [ControlIds.Values]: data.columns[0]?.id || ''
  }),
  getVisualizationData: (params: { data: TableDataJSON; controls: ControlValues }) => {
    const columnId = params.controls[ControlIds.Values] as string;
    const values = params.data.columns
      .find(col => col.id === columnId)
      ?.values
      .map(v => Number(v))
      .filter(v => !isNaN(v));
    
    if (!values || values.length === 0) return null;
    return calculateRange(values);
  },
  render: ({ visualizationData }) => <RangeCalculator visualizationData={visualizationData} />
}; 